import React from "react";

const LoaderForPage = () => {
  return (
    <div
      className="h-12 w-12 animate-spin rounded-full border-4 border-[#d8e7c7] border-t-primary"
      aria-label="Loading"
      role="status"
    />
  );
};

export default LoaderForPage;
